import { DeliveryCharge } from '../types';

const DELIVERY_CHARGE_KEY = 'cps_delivery_charge';

export const saveDeliveryCharge = (deliveryCharge: DeliveryCharge): void => {
  try {
    localStorage.setItem(DELIVERY_CHARGE_KEY, JSON.stringify(deliveryCharge));
  } catch (error) {
    console.error('Error saving delivery charge:', error);
  }
};

export const loadDeliveryCharge = (): DeliveryCharge | null => {
  try {
    const saved = localStorage.getItem(DELIVERY_CHARGE_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch (error) {
    console.error('Error loading delivery charge:', error);
    return null;
  }
};
